import resources from '../resources';
import Config from './config';
var EventEmitter2 = require('eventemitter2');
var socket = null;
var isConnecting = false;
var isOpen = false;
var reconnectTimer = null;
var service = new EventEmitter2({
  wildcard: true
});
var onOpen = function onOpen(event) {
  console.log('ConnectServer: connected');
  isOpen = true;
  isConnecting = false;
  resources.getToken().then(function (token) {
    return authenticate(token.accessToken);
  });
};
var onClose = function onClose(event) {
  isOpen = false;
  console.log('ConnectServer: disconnected');
  if (reconnectTimer) {
    return reconnectTimer;
  }
  // Attempt to reconnect
  return reconnectTimer = setInterval(function () {
    if (!isOpen) {
      return open();
    } else {
      clearInterval(reconnectTimer);
      return reconnectTimer = null;
    }
  }, 3000);
};
var open = function open() {
  isConnecting = true;
  isOpen = false;
  if (socket != null) {
    socket.close();
  }
  if (Config.connectServer.url == null) {
    console.log('ConnectServer: disabled (cloud)');
    return;
  }
  console.log('ConnectServer: connecting');
  socket = new WebSocket(Config.connectServer.url);
  socket.addEventListener('open', onOpen);
  socket.addEventListener('close', onClose);
  return socket.addEventListener('message', function (event) {
    var message = JSON.parse(event.data);
    return service.emit(message.resource.replace('/', '.'), message.payload || {});
  });
};
var close = function close() {
  if (socket == null) {
    return;
  }
  console.log('ConnectServer: disconnecting');
  socket.removeEventListener('open', onOpen);
  socket.removeEventListener('close', onClose);
  socket.close();
  isOpen = false;
};
var send = function send(message) {
  if (socket == null) {
    return false;
  }
  console.log('ConnectServer: sending: ', message);
  if (typeof message !== 'string') {
    message = JSON.stringify(message);
  }
  return socket.send(message);
};
var authenticate = function authenticate(token) {
  console.log('ConnectServer: authenticating');
  send({
    route: 'web/authenticate',
    payload: {
      token: token
    }
  });
};
service.open = open;
service.close = close;
service.send = send;
service.authenticate = authenticate;
service.isOpen = isOpen;
service.isConnecting = isConnecting;
export default service;